export const FETCHED = 'FETCHED';
export const READY = 'READY';
